<div class="extra-frame">
  <form [formGroup]="UserForm" (ngSubmit)="saveUser(UserForm.value)">
    <div>
      <div class="row">
        <div class="col-md-6 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_cyclist' | translate}}</div>
        <div class="col-md-3" *ngIf="user && user.ID">
          <button pButton type="button" class="p-button-raised full-width alternate" (click)="clearForm()"
                  label="{{ 'bikeshop.modal.shedule_service.reset_form' | translate}}"></button>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-12 label fontweight600">
          {{ 'bikeshop.modal.shedule_service.enter_either_email_or_phone_or_both' | translate }}
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-2 label"
             [ngClass]="{'red': user.ID === undefined && UserForm.controls['PhoneNumber'].enabled && !UserForm.value.Email && (!UserForm.value.PhoneNumber || UserForm.value.PhoneNumber.length===0)}">
          <span
            *ngIf="user.ID === undefined && UserForm.controls['Email'].enabled && (!UserForm.value.Email || UserForm.value.Email.length===0)">*</span>{{
          'general.phone_number' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-autoComplete formControlName="PhoneNumber" [suggestions]="cyclists"
                            placeholder="{{ 'general.phone_number_placeholder' | translate}}" [delay]="600"
                            (onSelect)="selectUser($event)" (completeMethod)="searchPhone($event)">
              <ng-template let-user pTemplate="item">
                <div><span>{{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}
                  / {{user.Name + ' ' +
                  user.Surname}} / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}}</span></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="col-md-2 label"
             [ngClass]="{'red': user.ID === undefined && UserForm.controls['Email'].enabled && !UserForm.value.PhoneNumber && (!UserForm.value.Email || UserForm.value.Email.length===0)}">
          <span
            *ngIf="user.ID === undefined && UserForm.controls['PhoneNumber'].enabled && (!UserForm.value.PhoneNumber || UserForm.value.PhoneNumber.length===0)">*</span>{{
          'general.email' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input type="text" pInputText formControlName="Email"
                   placeholder="{{ 'general.email_placeholder' | translate}}"
                   (change)="searchEmail($event)"/>
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-2 label"
             [ngClass]="{'red': user.ID === undefined && UserForm.controls['Name'].enabled && (!UserForm.value.Name || UserForm.value.Name.length===0)}">
          *{{ 'general.firstname' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-autoComplete formControlName="Name" [suggestions]="cyclists"
                            placeholder="{{ 'general.firstname_placeholder' | translate}}"
                            [forceSelection]="false"
                            (onSelect)="selectUser($event)" (completeMethod)="searchName($event)">
              <ng-template let-user pTemplate="item">
                <div><span>{{user.Name + ' ' + user.Surname}}
                  / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}} /
                  {{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}</span></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="col-md-2 label">
          {{ 'general.surname' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-autoComplete formControlName="Surname" [suggestions]="cyclists"
                            placeholder="{{ 'general.surname_placeholder' | translate}}"
                            [forceSelection]="false"
                            (onSelect)="selectUser($event)" (completeMethod)="searchSurname($event)">
              <ng-template let-user pTemplate="item">
                <div><span>{{user.Name + ' ' + user.Surname}}
                  / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}} /
                  {{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}</span></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
      </div>
    </div>

    <div class="row margin-top-16" *ngIf="!user.ID">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <button pButton type="submit" class="p-button-raised full-width"
                label="{{'bikeshop.modal.shared.cyclist-bike.button.create_cyclist' | translate}}"
                [disabled]="!UserForm.valid || !valid() || busy"></button>
      </div>
    </div>
    <div class="row margin-top-16" *ngIf="user.ID && nextCyclist !== null">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <button pButton class="p-button-raised full-width" (click)="next()"
                label="{{'bikeshop.bike_sale.buttons.next' | translate}}"
                [disabled]="!user.ID"></button>
      </div>
    </div>

    <div class="row" *ngIf="error">
      <div class="col-md-12 errormessage">{{errorMessage}}</div>
    </div>
  </form>

  <p-confirmDialog></p-confirmDialog>
</div>
